import type { BattleInvite } from "@/components/battle-invite-item";
import type { GameInviteData } from "@satranc365/shared";
import { StateCreator } from "zustand";

export interface ClassInvite {
    id: number;
    classId: number;
    className: string;
    classDescription: string | null;
    inviterName: string;
    inviterEmail: string;
    createdAt: Date;
    expiresAt: Date;
}

export interface NotificationSlice {
    classInvites: ClassInvite[];
    gameInvites: GameInviteData[];
    battleInvites: BattleInvite[];
    setClassInvites: (invites: ClassInvite[]) => void;
    setGameInvites: (invites: GameInviteData[]) => void;
    setBattleInvites: (invites: BattleInvite[]) => void;
    addGameInvite: (invite: GameInviteData) => void;
    addBattleInvite: (invite: BattleInvite) => void;
    removeGameInvite: (inviteId: number) => void;
    removeBattleInvite: (battleId: string) => void;
    clearInvites: () => void;
}

const createNotificationSlice: StateCreator<NotificationSlice> = (set) => ({
    classInvites: [],
    gameInvites: [],
    battleInvites: [],

    setClassInvites: (invites) => set({ classInvites: invites }),
    setGameInvites: (invites) => set({ gameInvites: invites }),
    setBattleInvites: (invites) => set({ battleInvites: invites }),

    addGameInvite: (invite) =>
        set((state) => {
            if (state.gameInvites.some((i) => i.inviteId === invite.inviteId)) {
                return state;
            }
            return { gameInvites: [invite, ...state.gameInvites] };
        }),

    addBattleInvite: (invite) =>
        set((state) => {
            if (
                state.battleInvites.some((i) => i.battleId === invite.battleId)
            ) {
                return state;
            }
            return { battleInvites: [invite, ...state.battleInvites] };
        }),

    removeGameInvite: (inviteId) =>
        set((state) => ({
            gameInvites: state.gameInvites.filter(
                (i) => i.inviteId !== inviteId,
            ),
        })),

    removeBattleInvite: (battleId) =>
        set((state) => ({
            battleInvites: state.battleInvites.filter(
                (i) => i.battleId !== battleId,
            ),
        })),

    clearInvites: () =>
        set({
            classInvites: [],
            gameInvites: [],
            battleInvites: [],
        }),
});

export default createNotificationSlice;
